import { HIRES, LG, MD, SM } from '@common/utils/imageutils';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/all';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ProductImage from './ProductImage';
import ProductImageButton from './ProductImageButton';
import ProductVideo from './ProductVideo';
import classNames from 'classnames';
import useBreakpoint from '@common/utils/useBreakpoint';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const imageSizes = [SM, MD, LG, HIRES];
const ProductVerticalGallery = (props) => {
    const { t } = useTranslation();
    const { product } = props;
    const breakpoint = useBreakpoint();
    const callback = (entries) => {
        let wrapperButtonVideo = document.querySelector('.container-product-button-video');
        entries.forEach((entry) => {
            if (wrapperButtonVideo) {
                if (entry.isIntersecting) {
                    wrapperButtonVideo.classList.remove('fixed');
                }
                else {
                    if (entry.boundingClientRect.y > 100) {
                        wrapperButtonVideo.classList.add('fixed');
                    }
                }
            }
        });
    };
    const observer = useRef(new IntersectionObserver(callback, { threshold: 0 })).current;
    // intersection observer on stickyTray
    useEffect(() => {
        let wrapperButtonVideo = document.querySelector('.container-product-button-video');
        if (wrapperButtonVideo && breakpoint >= window.mqObj.md) {
            observer.observe(wrapperButtonVideo);
            return () => observer.disconnect();
        }
    }, []);
    const heroGalleryImage = (mediaUrl, index) => {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            React.createElement(ProductImageButton, { onImageClick: () => props.onImageClick(index), clicked: props.clicked === index, ariaLabel: t('button.openProductGallery', { productName: (_a = product === null || product === void 0 ? void 0 : product.imgs) === null || _a === void 0 ? void 0 : _a.alt, index: index + 1, total: props.media.length }) }, mediaUrl.includes('_V1') ||
                mediaUrl.includes('_V2') ||
                mediaUrl.includes('_V3') ||
                mediaUrl.includes('_V4') ||
                mediaUrl.includes('_V5') ||
                mediaUrl.includes('_V6') ||
                mediaUrl.includes('_V7') ||
                mediaUrl.includes('_V8') ||
                mediaUrl.includes('_V9') ||
                mediaUrl.includes('_V10') ? (React.createElement("div", { className: "product-image" },
                React.createElement("div", { className: "product-video-wrapper" },
                    React.createElement(ProductVideo, { url: mediaUrl, isParfum: product === null || product === void 0 ? void 0 : product.isParfum })))) : (React.createElement(ProductImage, { img: { alt: (_b = product === null || product === void 0 ? void 0 : product.imgs) === null || _b === void 0 ? void 0 : _b.alt, urls: props.media }, sizes: imageSizes, index: index, productId: index == 0 ? product === null || product === void 0 ? void 0 : product.id : undefined }))),
            (mediaUrl.includes('_V1') ||
                mediaUrl.includes('_V2') ||
                mediaUrl.includes('_V3') ||
                mediaUrl.includes('_V4') ||
                mediaUrl.includes('_V5') ||
                mediaUrl.includes('_V6') ||
                mediaUrl.includes('_V7') ||
                mediaUrl.includes('_V8') ||
                mediaUrl.includes('_V9') ||
                mediaUrl.includes('_V10')) && (React.createElement("div", { className: "container-product-button-video" },
                React.createElement("button", { className: "product-video-pause is-parfum", "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false" })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('product-gallery-vertical', { 'mbm-gallery-vertical': props.product.isMbm }), id: `product-gallery-vertical-${props.product.uuid}` },
            React.createElement("ul", { className: classNames('product-gallery-vertical--list', {
                    'last-image-full': props.media.length == 2 || props.media.length == 5 || props.media.length == 8 || props.media.length == 11,
                }) }, props.media.map((url, index) => (React.createElement("li", { className: "product-gallery-vertical__image", key: `${props.product.id}-${index}`, id: `product-image-${index}`, style: { position: 'relative' } }, heroGalleryImage(url, index))))))));
};
export default ProductVerticalGallery;
